export { default } from './SpeedDial';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/esm/SpeedDial/index.js
// module id = 375
// module chunks = 0